export class Permission {
  _id = '';
  username = '';
  alias = '';
  description = '';
  name = '';
  isEdit = false;

  usernameErrorMsg = '';
  

  set(permission) {
    this._id = permission['_id'];
    this.name = permission['name'];
    this.alias = permission['alias'];
    this.description = permission['description'];
  }

}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_models/permission.ts